import { gql } from '@apollo/client';

export const RETURN_ORDERS = gql`
  query ReturnOrders($filter: ReturnOrderItemFilter, $sort: ReturnOrderSort) {
    returnOrders(filter: $filter, sort: $sort) {
      count
      data {
        id
        status
        toyCondition
        isLibraryDamageRequestGenerated
        inventoryUnits {
          id
          qrCode
          unitCode
          status
          shelfLocation
          rack {
            id
            name
          }
        }
        includedContents {
          id
          quantity
          value
        }
        contentHistory {
          id
          newContent {
            id
            quantity
            value
          }
          oldContent {
            id
            quantity
            value
          }
          status
          createdAt
        }
        deliveryAttachments {
          key
          url
          deliveryAttachmentsType
        }
        returnedOn
        productRate
        videoUrl
        images {
          key
          url
        }
        orderItem {
          toy {
            id
            type
            ageGroups {
              id
              minAge
              maxAge
            }
            brand {
              id
              name
            }
            bag {
              id
              name
              size
              image
            }
            images {
              contentType
              key
              order
              size
              url
            }
            name
            toyNumber
          }
        }
        order {
          metadata
          orderNumber
          deliveryType
        }
        libraryInventory {
          id
          library {
            name
            libraryNumber
          }
        }
        returnOrder {
          metadata
          id
          returnOrderNumber
          partnerOrderId
          receivingLibraryId
          receiverLibrary {
            id
            libraryNumber
            name
          }
          library {
            id
            libraryNumber
            name
          }
          pincode {
            pincode
          }
          user {
            userNumber
          }
          deliveryPartner {
            firstName
            lastName
            id
            userNumber
          }
          orderTags
        }
        createdAt
      }
    }
  }
`;

export const TOY_DAMAGE_INSPECTION_FORM = gql`
  query ToyDamageInspectionForm($where: ToyUniqueInput!) {
    toyAdmin(where: $where) {
      requiredContents
      checklist
    }
  }
`;

export const GET_LIBRARY_DAMAGE_REQUEST_IMAGE_SINGED_PUT_URL = gql`
  query GetLibraryDamageRequestImageSignedPutUrl(
    $data: GetLibraryDamageRequestSignedPutUrlV2Input
  ) {
    getLibraryDamageRequestImageSignedPutUrl(data: $data) {
      fileName
      signedUrl
    }
  }
`;

export const GET_LIBRARY_REQUEST_TOY_VIDEO_SIGNED_PUT_URL = gql`
  query GetLibraryRequestToyVideoSignedPutUrl(
    $data: GetLibraryDamageRequestSignedPutUrlInput!
  ) {
    getLibraryRequestToyVideoSignedPutUrl(data: $data) {
      fileName
      signedUrl
    }
  }
`;

export const ORDERS = gql`
  query Orders($filter: OrderFilter, $sort: OrderSort) {
    orders(filter: $filter, sort: $sort) {
      count
      confirmedOrderCount
      data {
        isPreOrder
        isDelayed
        library {
          city
          id
        }
        isExpressDelivery
        isQuickDelivery
        totalOrdersCount
        isFirstOrder
        delayedInConfirmed
        delayedInShipped
        metadata
        orderNumber
        partnerOrderId
        expectedDeliveryDate
        id
        transferOrderItemCount
        deliveryType
        orderType
        deliveryService
        orderItemCount
        deliveryAttachments {
          key
          url
          deliveryAttachmentsType
        }
        cancelledBy
        deliveredOn
        deliveryPartner {
          id
          userNumber
          firstName
          lastName
        }
        pincode {
          pincode
        }
        user {
          userNumber
          firstName
          lastName
          id
        }
        createdAt
        status
        statusHistory {
          newStatus
          oldStatus
          createdAt
        }
        cancellationData {
          date
          additionalComment
          reason
          type
        }
        comment {
          isResolved
          comment
        }
        currentStatusTime
        nextStatusTime
        orderTags
        scheduledOrders {
          id
          orderNumber
        }
      }
      configs {
        id
        key
        type
        value
      }
    }
  }
`;

// Same shape/variables as ORDERS, aliased to `orders` so the table's existing
// response handling works unchanged. Only the backend resolver name differs.
export const FULFILMENT_POSSIBILITY_ORDERS = gql`
  query FulfilmentPossibilityOrders($filter: OrderFilter, $sort: OrderSort) {
    orders: fulfilmentPossibilityOrders(filter: $filter, sort: $sort) {
      count
      data {
        picker {
          id
          firstName
          lastName
          userNumber
        }
        packer {
          id
          firstName
          lastName
          userNumber
        }
        inventoryUnits {
          id
          qrCode
          unitCode
          status
          shelfLocation
          rack {
            id
            name
          }
        }
        id
        status
        isPreOrder
        quantity
        stockAtBooking
        toy {
          id
          toyNumber
          name
          brand {
            id
            name
          }
          bag {
            id
            name
            size
            image
          }
          images {
            key
            url
          }
        }
        libraryInventory {
          id
          availableStock
          physicallyAvailableStock
          pendingDispatchCount
          rentedOut
          totalStock
        }
        transferOrders {
          id
          status
          transferOrderNumber
        }
        order {
          id
          orderNumber
          status
          isDelayed
          isExpressDelivery
          isQuickDelivery
          totalOrdersCount
          hasReservedItems
          isFirstOrder
          delayedInConfirmed
          transferOrderItemCount
          orderItemCount
          metadata
          deliveryService
          expectedDeliveryDate
          deliveryType
          orderType
          deliveryAttachments {
            key
            url
            deliveryAttachmentsType
          }
          cancelledBy
          deliveredOn
          createdAt
          currentStatusTime
          nextStatusTime
          deliveryPartner {
            id
            userNumber
            firstName
            lastName
          }
          pincode {
            pincode
          }
          library {
            city
            name
            id
            libraryNumber
          }
          user {
            id
            userNumber
            firstName
            lastName
            pincode {
              pincode
            }
          }
          cancellationData {
            date
            additionalComment
            reason
            type
          }
          comment {
            isResolved
            comment
          }
          orderTags
        }
      }
      configs {
        id
        key
        type
        value
      }
    }
  }
`;

export const ORDERS_COUNT = gql`
  query Orders($filter: OrderFilter, $sort: OrderSort) {
    orders(filter: $filter, sort: $sort) {
      count
      confirmedOrderCount
    }
  }
`;

export const FULFILMENT_POSSIBILITY_ORDERS_COUNT = gql`
  query FulfilmentPossibilityOrdersCount(
    $filter: OrderFilter
    $sort: OrderSort
  ) {
    orders: fulfilmentPossibilityOrders(filter: $filter, sort: $sort) {
      count
    }
  }
`;

export const ORDER_ITEMS = gql`
  query OrderItems($where: OrderUniqueInput) {
    orderItems(where: $where) {
      count
      data {
        picker {
          id
          firstName
          lastName
          userNumber
        }
        packer {
          id
          firstName
          lastName
          userNumber
        }
        inventoryUnits {
          id
          qrCode
          unitCode
          status
          shelfLocation
          rack {
            id
            name
          }
        }
        isPreOrder
        stockAtBooking
        libraryInventory {
          id
          availableStock
          physicallyAvailableStock
          pendingDispatchCount
        }
        order {
          orderNumber
        }
        id
        returnDate
        adminNote
        transferOrders {
          status
        }
        contentHistory {
          id
          newContent {
            id
            quantity
            value
          }
          oldContent {
            id
            quantity
            value
          }
          status
          createdAt
        }
        comment {
          isResolved
          comment
        }
        rack {
          id
          name
        }
        cancellationData {
          additionalComment
          date
          reason
          type
        }
        toy {
          id
          toyNumber
          name
          ageGroups {
            id
            minAge
            maxAge
          }
          brand {
            id
            name
          }
          images {
            contentType
            key
            order
            size
            url
          }
          bag {
            id
            name
            size
            image
          }
        }
        status
      }
    }
  }
`;

export const ORDERS_SELECT = gql`
  query Orders($filter: OrderFilter, $sort: OrderSort) {
    orders(filter: $filter, sort: $sort) {
      count
      data {
        orderNumber
        id
      }
    }
  }
`;

export const RETURN_ORDERS_SELECT = gql`
  query returnOrders($filter: ReturnOrderItemFilter, $sort: ReturnOrderSort) {
    returnOrders(filter: $filter, sort: $sort) {
      count
      data {
        returnOrder {
          id
          returnOrderNumber
        }
      }
    }
  }
`;

export const GET_ORDER_CHALLAN_DOWNLOAD_URL = gql`
  query GetOrderChallanDownloadUrl($where: OrderUniqueInput!, $orderIds: [ID]) {
    getOrderChallanDownloadUrl(where: $where, orderIds: $orderIds) {
      challanUrl
    }
  }
`;

export const GET_ORDER_STICKER_DOWNLOAD_URL = gql`
  query GetOrderStickerDownloadUrl($where: OrderItemUniqueInput!) {
    getOrderStickerDownloadUrl(where: $where) {
      stickerUrl
    }
  }
`;

export const CONTENT_MASTERS = gql`
  query ContentMasters($filter: ContentMasterFilter, $sort: ContentMasterSort) {
    contentMasters(filter: $filter, sort: $sort) {
      count
      data {
        id
        key
        value
      }
    }
  }
`;
